export default __webpack_public_path__ + "static/MediaContentFive-aefd76308e73ca17a7316d1683f1c7bb.webp";